import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {disColData} from 'src/app/components/external-dashboards/s-table-pg/s-table-pg.component';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import {MyOrdersService} from './my-orders-table.service';
import {RequestApiService} from 'src/app/services/domain_code/request-api.service';
import {MatDialog} from '@angular/material/dialog';
import {AckRequestService} from 'src/app/services/ack-request.service';
import {BackendListModel} from 'src/app/models/common/list.model';
import {RequestStatus} from 'src/app/models/request-status';
import {AuthService} from 'src/app/services/auth.service';
import {Router} from '@angular/router';
import {Subscription, interval} from 'rxjs';
import {
    BehaviorSubject,
    startWith,
    debounceTime,
    distinctUntilChanged,
    map,
} from 'rxjs';
import {ApiRoutes} from 'src/app/services/apiroutes';
import {RequestFiltersClass} from 'src/app/models/request-filters';
import {RequestListRootObject} from './new-request.model';
import {ChatService} from 'src/app/services/chat.service';
import {MyRequestsService} from '../my-requests-table/my-requests-table.service';

@Component({
    selector: 'logzy-orders-table',
    templateUrl: './my-orders-table.component.html',
    styleUrls: ['./my-orders-table.component.scss']
})
export class MyOrdersTableComponent implements OnInit, OnDestroy {

    @Input()
    groupId;

    @Output()
    requestCount = new EventEmitter<number>();

    requestList: MatTableDataSource<RequestListRootObject>;
    requestDetails;
    // prevRequestIds = [];
    // currRequestIds = [];
    // newRequestIds = [];
    pageLength = 0;
    // pageSize = 10;
    // pageIndex = 0;
    searchTerm = '';
    loading: boolean = true;
    isFirstLoad = true;

    @ViewChild('title') title: any;
    @ViewChild('input') input: ElementRef;

    dropped: boolean = false;
    screenHeight: number;
    screenWidth: number;
    shadowX!: number;
    shadowY!: number;
    errorObj: any = {};
    status_List: BackendListModel<RequestStatus>;
    popup_status_button_data = [];
    isCustomer: boolean = this.authService.isCustomer();

    @Input()
    update: boolean = true;

    @Output()
    updateChange = new EventEmitter<boolean>();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @Input() displayedColumns: string[] | undefined;
    @Input() displayedColumnData: disColData[] | undefined;
    @Output() pageSizeOptions = new EventEmitter<string>();
    // @Output() viewer = new EventEmitter<boolean>();
    @Output() edit = new EventEmitter<any>();
    @Output() accept = new EventEmitter<any>();
    @Output() reject = new EventEmitter<any>();
    @Output() transfer = new EventEmitter<any>();
    @Output() cancel = new EventEmitter<any>();
    @Output() filterRequest = new EventEmitter<any>();

    @Input()
    searchText = new BehaviorSubject<string>('')
    // searchRequest=new BehaviorSubject<string>('');

    // requestType: string = "";
    requestNumber: string;
    customerName: string;
    pickupLocation: string;
    dropOffLocation: string;


    periodicRefresh: any;

    @Output() totalRecords = new EventEmitter<number>();

    subscription: Subscription;
    requestNo = '';
    latestQuotes;
    timeoutId: ReturnType<typeof setTimeout>;
    loadCommercials: boolean = false;
    request_url = `${ApiRoutes.LeadRequest}request_details/`;
    location_url = `${ApiRoutes.Location}?location_type_name=port&search=::search::`;

    // open: string = "sidepanel";
    // canvas: string = "Canvas";
    // Opencanvas: boolean = false;

    constructor(public myOrderService: MyOrdersService,
                private myRequestService: MyRequestsService,
                private requestService: RequestApiService,
                public dialog: MatDialog, public ackRequest: AckRequestService,
                private authService: AuthService,
                private router: Router, private chatService: ChatService
    ) {
        this.screenHeight = (window.screen.height)
        this.screenWidth = (window.screen.width)
    }


    onMouseMove(e: any) {
        this.dropped = true;
        if (e.clientX < (this.screenWidth / 2)) {//right shadow
            this.shadowX = 5;
        } else if (e.clientX > (this.screenWidth / 2)) {//left shadow
            this.shadowX = -5;
        }
        if (e.clientY > (this.screenHeight / 2)) {//top shadow
            this.shadowY = -4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        } else if (e.clientY < (this.screenHeight / 2)) {//bottom shadow
            this.shadowY = 4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        }
    }

    displayColumns = ['transaction_type_display', 'request_number', 'pols', 'pods', 'equipment', 'requestor', 'external_reference_no', 'request_date', 'request_source', 'status',]

    ngOnInit(): void {
        if (this.isCustomer) {
            this.displayColumns = ['transaction_type_display', 'request_number', 'pols', 'pods', 'equipment', 'requestor', 'request_date', 'status',]
        } else {
            this.displayColumns = ['transaction_type_display', 'request_number', 'pols', 'pods', 'equipment', 'requestor', 'external_reference_no', 'request_date', 'request_source', 'status',]
        }

        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                this.myOrderService.listQPModel.search = searchText;
                this.myOrderService.listQPModel.page = 1;
                // this.getRequestDetailsByGroup(this.groupId, searchText);
                this.getRequestDetailsByFilters(this.groupId, this.myOrderService.listQPModel);
            })
        ).subscribe();

        this.reinitializePeriodicRefresh();
        this.myOrderService.filterSubject.subscribe(data => {
            // console.log("Check Filter Data", data)
            if (this.groupId == null && this.myOrderService.filtersAdded) {
                this.getRequestDetailsByFilters(this.groupId, data);
            }

            if (this.groupId != null && !this.myOrderService.filtersAdded) {
                this.getRequestDetailsByFilters(this.groupId, data);
            }
        });

    }

    ngOnDestroy() {
        if (this.periodicRefresh) {
            this.periodicRefresh.unsubscribe();
        }
    }

    reinitializePeriodicRefresh() {
        if (this.periodicRefresh) {
            this.periodicRefresh.unsubscribe();
        }
        this.periodicRefresh = interval(1000 * 60 * 5).subscribe(() => {
            // this.getRequestDetailsByGroup(this.groupId, this.searchTerm);
            this.getRequestDetailsByFilters(this.groupId, this.myOrderService.listQPModel)
        });
    }

    ngAfterViewInit() {
        if (this.requestList != null) {
            this.requestList.paginator = this.paginator;
            this.requestList.sort = this.sort;
        }
    }

    // listQPModel = new RequestFiltersClass();

    // getRequestDetailsByGroup(groupId = '', searchTerm = null, pageSize = null, pageIndex = null, ordering = '') {
    //     pageSize = pageSize || this.pageSize;
    //     pageIndex = pageIndex || this.pageIndex;
    //     if (searchTerm != null) {
    //         this.searchTerm = searchTerm;
    //     }

    //     this.prevRequestIds = [...this.currRequestIds];

    //     this.myOrderService.getRequestDetailsByGroup(groupId, this.searchTerm, pageSize, pageIndex + 1, ordering).subscribe({
    //         next: response => {
    //             this.requestList = new MatTableDataSource(response.results);
    //             this.requestDetails = response.results;
    //             this.pageLength = response.count;
    //             this.myOrderService.groupInfo[groupId] = { pageLength: response.count };
    //             this.loading = false;
    //             this.update = false;
    //             this.updateChange.emit(false);
    //         },
    //         error: error => {
    //             return error;
    //         }
    //     });
    // }
    getRequestDetailsByFilters(groupId = '', listQPModel) {
        // this.myOrderService.listQPModel.page_size = this.myOrderService.listQPModel.page_size || this.pageSize;
        // this.myOrderService.listQPModel.page = this.myOrderService.listQPModel.page || this.pageIndex;
        if (this.myOrderService.listQPModel.search != null) {
            this.searchTerm = this.myOrderService.listQPModel.search;
        }

        this.myOrderService.getRequestDetailsByFilters(groupId, listQPModel).subscribe({
            next: response => {
                for (let i = 0; i < response.results.length; i++) {
                    response.results[i].req_pols = [];
                    response.results[i].req_pods = [];
                    for (let j = 0; j < response.results[i].requirement.length; j++) {
                        for (let k = 0; k < response.results[i].requirement[j].pol_list.length; k++) {
                            response.results[i].req_pols = this.union(response.results[i].req_pols, response.results[i].requirement[j].pol_list);
                        }
                        for (let k = 0; k < response.results[i].requirement[j].pod_list.length; k++) {
                            response.results[i].req_pods = this.union(response.results[i].req_pods, response.results[i].requirement[j].pod_list);
                        }
                    }
                }
                this.requestList = new MatTableDataSource(response.results);
                this.requestDetails = response.results;
                this.pageLength = response.count;
                this.requestCount.emit(response.count)
                this.myOrderService.groupInfo[groupId] = {pageLength: response.count};
                this.loading = false;
                this.update = false;
                this.updateChange.emit(false);
            },
            error: error => {
                return error;
            }
        });
    }

    isToday = date => {
        const today = new Date();
        const givenDate = new Date(date);
        return givenDate.getDate() === today.getDate() &&
            givenDate.getMonth() === today.getMonth() &&
            givenDate.getFullYear() === today.getFullYear()
    }

    /** Announce the change in sort state for assistive technology. */
    announceSortChange(sortState: Sort) {
        this.update = true;
        switch (sortState.direction) {
            case 'asc':
                this.myOrderService.listQPModel.o = sortState.active;
                // this.getRequestDetailsByGroup(this.groupId, this.searchTerm, this.pageSize, this.pageIndex, sortState.active);
                this.getRequestDetailsByFilters(this.groupId, this.myOrderService.listQPModel)
                break;

            case 'desc':
                this.myOrderService.listQPModel.o = `-${sortState.active}`;
                // this.getRequestDetailsByGroup(this.groupId, this.searchTerm, this.pageSize, this.pageIndex, `-${sortState.active}`);
                this.getRequestDetailsByFilters(this.groupId, this.myOrderService.listQPModel)
                break;

            default:
                this.myOrderService.listQPModel.o = null
                // this.getRequestDetailsByGroup(this.groupId, this.searchTerm, this.pageSize, this.pageIndex);
                this.getRequestDetailsByFilters(this.groupId, this.myOrderService.listQPModel)
        }
    }

    pageChanged(event: PageEvent) {
        this.update = true;
        console.log({event});
        // this.pageSize = event.pageSize;
        this.myOrderService.listQPModel.page_size = event.pageSize
        // this.pageIndex = event.pageIndex + 1;
        this.myOrderService.listQPModel.page = event.pageIndex + 1;
        this.getRequestDetailsByFilters(this.groupId, this.myOrderService.listQPModel)
    }

    view(requestData) {
        this.chatService.resetDocumentTitle();
        // this.viewer.emit(true);
        this.requestService.selectedRequest = {...requestData};
        if (requestData.id != null && requestData.id != undefined) {
            if (this.authService.isCustomer()) {
                this.router.navigateByUrl(`/client-dashboard/my-orders/my-order-details?id=${requestData.id}&type=${requestData.transaction_type}&rtype=${requestData.request_type.dev_name}`);
            }
            if (!this.authService.isCustomer()) {
                this.router.navigateByUrl(`/requests/request-processing/request-details?id=${requestData.id}&type=${requestData.transaction_type}&rtype=${requestData.request_type.dev_name}`);
            }
        }
    }

    editRequest(requestData) {
        this.edit.emit(requestData);
        console.log("requestData", requestData)
        this.requestService.selectedRequest = {...requestData};
    }

    acceptRequest(requestData) {
        this.accept.emit('Accept Request');
        console.log("requestData", requestData)
        this.ackRequest.selectedRequest = {...requestData};
        console.log("request_number", this.ackRequest)
    }

    rejectRequest(requestData) {
        this.reject.emit('Reject Request');
        console.log("requestData", requestData)
        this.ackRequest.selectedRequest = {...requestData};
        console.log("request_number", this.ackRequest)
    }

    transferRequest(requestData) {
        this.transfer.emit('Share Request');
        console.log("requestData", requestData)
        this.ackRequest.selectedRequest = {...requestData};
        console.log("request_number", this.ackRequest)
    }

    defaultRequest(requestData, item) {
        this.cancel.emit('Default Request');
        console.log("requestData", requestData)
        this.ackRequest.selectedRequest = {...requestData};
        this.ackRequest.selecteddevName = {...item};
    }

    filterByRequestType(event) {
        this.update = true;
        if (this.paginator) {
            this.paginator.pageIndex = 0;
            this.myOrderService.listQPModel.page = this.paginator.pageIndex + 1;
        }
        this.myOrderService.listQPModel.request_type = event;
        this.getRequestDetailsByFilters(this.groupId, this.myOrderService.listQPModel)
    }

    getStatusbyRequestbyId(data) {
        this.popup_status_button_data = [];
        this.ackRequest.getRequestStatus(data.status.id).subscribe(response => {
            if (JSON.parse(localStorage.getItem('current_user')).role == 'customer') {

                this.popup_status_button_data = response.results;
            }
            console.log("Request Status", this.popup_status_button_data)
        })
    }

    changeStatus(item, data) {
        if (item.dev_name == "accepted_by_internal_user") {
            this.acceptRequest(data);
        } else if (item.dev_name == "reject_by_internal_user" ||
            item.dev_name == "reject_by_internal_user_after_acceptance" ||
            item.dev_name == "rejected_by_external_user_after_booking_confirmed" ||
            item.dev_name == "cancelled_by_external_user" ||
            item.dev_name == "cancelled_by_external_user_after_acceptance") {
            this.rejectRequest(data);
        } else if (item.dev_name == "transferred_internal" || item.dev_name == "shared_by_internal") {
            this.transferRequest(data);
        } else if (item.dev_name == "request_altered_by_internal_user" || item.dev_name == "request_altered_by_external_user_before_internal_ack") {
            this.editRequest(data);
        } else {
            this.defaultRequest(data, item);
        }
    }

    // Function to catch errors
    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = {...error.error};
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = {...error.error};
            return error;
        }
    }

    showCommercials(data) {
        this.latestQuotes = [];
        this.requestNo = '';
        this.requestNo = data.request_number;
        // if (data.request_type.dev_name !== 'lease') {
        this.loadCommercials = true;
        this.timeoutId = setTimeout(() => {
            this.subscription = this.requestService.getCommercials(data.id, data.request_type.dev_name == 'one_way' ? 'oneway' :
                data.request_type.dev_name == 'lease' ? 'lease' :
                    data.request_type.dev_name == 'buy_sell' ? 'trade' :
                        data.request_type.dev_name == 'empty_repo' ? 'empty_repo' : ''
            ).subscribe({
                next: response => {
                    console.log('showCommercials', response);
                    this.latestQuotes = response;
                    this.loadCommercials = false;
                },
                error: error => {
                    console.log("Error Status", error);
                    if (error.status == 404) {
                        this.latestQuotes = null;
                    }
                }
            });
        }, 100);
        // }
    }

    cancelSubscription() {
        this.requestNo = '';
        clearTimeout(this.timeoutId);
        this.loadCommercials = false;
        if (this.subscription != undefined) {
            if (!this.subscription.closed)
                this.subscription.unsubscribe();
        }
    }

    openRequestFilterSidePanel() {
        this.filterRequest.emit();
    }

    clearFilters() {
        if (this.authService.getAuthStatus()) {
            this.loading = true
            this.update = true
            this.myOrderService.listQPModel = new RequestFiltersClass();
            this.myOrderService.filtersAdded = false;
            this.myOrderService.updateFilterSubjectValue(this.myOrderService.listQPModel);
            this.myRequestService.filterList = new RequestFiltersClass();
            this.myRequestService.filtersAdded = false;
            this.myRequestService.filterSubject.next(this.myRequestService.filterList);
            // this.filtersAdded = false;
            // this.loading = false;
        }
    }

    // closeRequestFilterSidePanel() {
    //     this.open = " sidepanel";
    //     this.canvas = "Canvas";
    //     this.Opencanvas = false;
    // }

    union(setA, setB) {
        for (let i = 0; i < setA.length; i++) {
            for (let j = 0; j < setB.length; j++) {
                if (setA[i].id == setB[j].id) {
                    setB.splice(j, 1);
                    j--
                }
            }
        }
        if (setB.length == 0) {
            return setA;
        } else {
            return setA.concat(setB);
        }
    }
}
